import Vue from 'vue';

Vue.filter('dateFormat', (value, format = 'YYYY-MM-DD HH:mm:ss') => {
  const date = new Date(value);
  return date.toString() === 'Invalid Date' ? value : _dayjs(date).format(format);
});

Vue.filter('dateFormatDayofWeek', (value, format = 'YYYY-MM-DD(dd)') => {
  const date = new Date(value);
  return date.toString() === 'Invalid Date' ? value : _dayjs(date).format(format);
});

Vue.filter('stringDateFormat', (value, inputFormat = 'YYYY-MM-DD HH:mm:ss', outputFormat = 'YYYY-MM-DD HH:mm') => {
  const date = _dayjs(value, inputFormat);
  return date.isValid() ? date.format(outputFormat) : value;
});
Vue.filter('stringDateFormatYMD', (value, inputFormat = 'YYYY-MM-DD HH:mm:ss', outputFormat = 'YYYY-MM-DD') => {
  const date = _dayjs(value, inputFormat);
  return date.isValid() ? date.format(outputFormat) : value;
});
Vue.filter('stringDateFormatHMHM', (startTime, endTime, inputFormat = 'YYYY-MM-DD HH:mm:ss', outputFormat = 'HH:mm') => {
  const end = _dayjs(endTime, inputFormat);
  const start = _dayjs(startTime, inputFormat);
  return start.isValid() && end.isValid() ? `${start.format(outputFormat)} ～ ${end.format(outputFormat)}` : '--';
});
Vue.filter('emptyFormat', (value) => ((value === null || value === undefined) ? '-' : value));

Vue.filter('emptyStringFormat', (value) => ((value === '') ? '--' : value));
Vue.filter('addCommaWithoutLast', (index, totalLength) => ((index === totalLength) ? '' : '、'));
Vue.filter('classSplit', (classStr) => ((classStr !== null && classStr !== '') ? classStr.substr(-2, 2) : ''));
